import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";

type TReadonlyEmailFieldProps = {
  label: string;
  email?: string | null;
  required?: boolean;
};

// Disabled-style read-only email box, matching the edit screen's non-editable email display.
// Fixed 320px width and top label to mirror the change-email form fields.
export const ReadonlyEmailField: FC<TReadonlyEmailFieldProps> = ({ label, email, required }) => {
  return (
    <Stack gap="8px" width="320px" maxWidth="100%">
      <Typography variant="cap12" color={text.primary}>
        {label}
        {required && (
          <Typography component="span" variant="cap12Bold" color={text.error}>
            {" *"}
          </Typography>
        )}
      </Typography>
      <Box
        sx={{
          minHeight: "33px",
          display: "flex",
          alignItems: "center",
          px: "8px",
          py: "6px",
          borderRadius: rounded.xs,
          border: `1px solid ${divider.middle}`,
          background: background.disable,
        }}
      >
        <Typography variant="body14" color={text.primary}>
          {email ?? "-"}
        </Typography>
      </Box>
    </Stack>
  );
};
